/**
 * Copyright © 2026 Delicious AI, LLC
 */

import { Box, Link, Stack, Typography } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'

import FirebaseAuthWidget from '@/components/auth/FirebaseAuthWidget'
import useT from '@/i18n/useT'

function SignIn() {
  const { t } = useT()

  return (
    <Stack spacing={3}>
      <Box sx={{ width: '100%' }}>
        <FirebaseAuthWidget className="dai-firebase" />
      </Box>
      <Typography sx={{ textAlign: 'center' }}>
        {t('login.noAccountYet.message')}{' '}
        <Link to="/auth/sign-up" component={RouterLink}>
          {t('login.signUp')}
        </Link>
      </Typography>
    </Stack>
  )
}

export default SignIn
